import React, {FC, ReactNode} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {ClickEventHandler} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {RepositionPopover} from '../../../../libs/shared/ui/src/components/popovers/repositionPopover';
import {Anchor} from '../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {FloatingToolbar} from '../floatingBars/floatingToolbar';
import {FloatingToolbarButton} from '../floatingBars/floatingToolbarButton';

interface FloatingMultiSelectCopyToolbarButtonProps {
  onRequestClose: () => void;
  label: ReactNode;
  anchor: Anchor;
  onClick: ClickEventHandler;
}

export const FloatingMultiSelectCopyToolbarButton: FC<FloatingMultiSelectCopyToolbarButtonProps> = (
  props,
) => (
  <RepositionPopover
    anchor={props.anchor}
    placement="right-end"
    onRequestClose={props.onRequestClose}
    isExclusive={false}
    isInline
  >
    <FloatingToolbar size={VisualSizesEnum.SMALL}>
      <FloatingToolbarButton
        iconName="copySmall"
        label={props.label}
        size={VisualSizesEnum.SMALL}
        onClick={props.onClick}
        keyboardAction={KeyboardActionsEnum.COPY}
        customMargin={5}
      />
    </FloatingToolbar>
  </RepositionPopover>
);
